module.exports = __webpack_public_path__ + "static/media/payments.e9e6087f.svg";